angular.module('omfm').directive('wkBooleanSelect', WkBooleanSelectDirective);

WkBooleanSelectDirective.$inject = [];

function WkBooleanSelectDirective() {
	return {
		restrict:    "EA",
		replace:     true,
		scope:       {
			value: "="
		},
		templateUrl: "/app/omfm/templates/wkBooleanSelect.html",
		link:        function ($scope) {

		}
	}
}